import { Expose } from "class-transformer";
import { UserAccessStatusEnum } from "@altertec_gparn/lib";

export class UpdateUserAccessDto {
  @Expose()
  id: string;

  @Expose()
  username?: string;

  @Expose()
  email?: string;

  @Expose()
  password?: string;

  @Expose()
  roleId?: string;

  @Expose()
  archived?: boolean;

  @Expose()
  accessStatus?: UserAccessStatusEnum;

  @Expose({ name: "accessToOperativeUnitIds" })
  accessToOperativeUnits: string[];
}
